module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0020.4b887843.jpg";